import { render, staticRenderFns } from "./detailOutbound.vue?vue&type=template&id=57624d39&scoped=true&"
import script from "./detailOutbound.vue?vue&type=script&lang=js&"
export * from "./detailOutbound.vue?vue&type=script&lang=js&"
import style0 from "./detailOutbound.vue?vue&type=style&index=0&id=57624d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57624d39",
  null
  
)

export default component.exports